import axios from "axios";
import constants from "@/constants";
import { getAuth, onAuthStateChanged } from "firebase/auth";

class CategoryGetters {
  static async getCategoryById(categoryId) {
    return new Promise((resolve, reject) => {
      const auth = getAuth();
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
          auth.currentUser
            .getIdToken(/* forceRefresh */ true)
            .then((idToken) => {
              const url = `${constants.apiUrl}/event-categories-getters/get-event-category/${categoryId}`;

              const config = {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json;charset=UTF-8",
                  Authorization: `Bearer ${idToken}`,
                },
              };

              axios
                .get(url, config)
                .then((data) => {
                  const response = data.data;
                  unsubscribe();
                  resolve(response);
                })
                .catch((err) => {
                  reject(err);
                });
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    });
  }

  static async getAllCategories(companyId) {
    return new Promise((resolve, reject) => {
      const auth = getAuth();
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
          auth.currentUser
            .getIdToken(/* forceRefresh */ true)
            .then((idToken) => {
              const url = `${constants.apiUrl}/event-categories-getters/get-event-categories/${companyId}`;

              const config = {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json;charset=UTF-8",
                  Authorization: `Bearer ${idToken}`,
                },
              };

              axios
                .get(url, config)
                .then((data) => {
                  const response = data.data;
                  unsubscribe();
                  resolve(response);
                })
                .catch((err) => {
                  reject(err);
                });
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    });
  }
}

export default CategoryGetters;
